import { mainMenuInitialState } from "./uiLandingPageMainMenuState";
import { makeMainMenuActions } from "./uiLandingPageMainMenuActions";

export const createMainMenuSlice = (set, get) => ({
  mainMenu: mainMenuInitialState,
  mainMenuActions: Object.freeze(makeMainMenuActions(set, get)),
});
